// Merch product: swap the fallback <select> for option buttons and keep the chosen variant in sync
// (price, availability, ?variant= and the photo of the chosen colour).
(() => {
  document.querySelectorAll('[data-pr-merch]').forEach((root) => {
    const data = root.querySelector('[data-pr-variants]');
    const fallback = root.querySelector('[data-pr-fallback]');
    const options = root.querySelector('[data-pr-options]');
    if (!data || !fallback || !options) return;

    const variants = JSON.parse(data.textContent);
    const select = fallback.querySelector('select');
    const price = root.querySelector('[data-pr-price]');
    const submit = root.querySelector('[data-pr-submit]');
    const gallery = root.querySelector('[data-pr-gallery]');
    const inputs = [...options.querySelectorAll('[data-pr-option]')];
    const groups = [...new Set(inputs.map((input) => Number(input.dataset.prOption)))];

    // The select keeps name="id" so the form still posts the variant; it is only visually replaced.
    fallback.hidden = true;
    options.hidden = false;

    const selected = () =>
      groups.map((group) => inputs.find((input) => Number(input.dataset.prOption) === group && input.checked)?.value);

    const update = () => {
      const chosen = selected();
      const variant = variants.find((v) => v.options.every((value, i) => value === chosen[i]));

      // Mark values that can't be bought with the other current choices (visible, struck, still selectable).
      inputs.forEach((input) => {
        const group = Number(input.dataset.prOption);
        const available = variants.some(
          (v) => v.available && v.options[group] === input.value && v.options.every((value, i) => i === group || value === chosen[i])
        );
        input.nextElementSibling.classList.toggle('is-unavailable', !available);
        if (groups.length === 1) input.disabled = !available;
      });

      groups.forEach((group) => {
        const label = options.querySelector(`[data-pr-option-label="${group}"]`);
        if (label) label.textContent = chosen[group] ?? '';
      });

      if (!variant) {
        submit.disabled = true;
        submit.textContent = submit.dataset.labelSold;
        return;
      }

      // The chosen colour's photo comes to the front of the gallery
      const photo = variant.media && gallery?.querySelector(`[data-media-id="${variant.media}"]`);
      if (photo && photo !== gallery.firstElementChild) {
        photo.querySelector('img')?.setAttribute('loading', 'eager');
        gallery.prepend(photo);
        gallery.scrollTo({ left: 0 });
      }

      select.value = String(variant.id);
      price.textContent = variant.price;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? submit.dataset.labelAdd : submit.dataset.labelSold;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    options.addEventListener('change', update);
    update();
  });
})();
